import React from 'react';

import InfoBox from 'components/InfoBox';

import { FormContextConsumer } from './FormContext';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const GeneralError = ({
  match,
  ignore,
}: {
  match?: string;
  ignore?: Array<string | null | undefined>;
}) => (
  <FormContextConsumer>
    {({ errors }) => {
      const error = errors[''] || errors.general;

      if (
        !error ||
        (match && error !== match) ||
        (ignore && ignore.includes(error))
      ) {
        return null;
      }

      return (
        // className used to scroll to error
        <InfoBox className="error" type="danger" mb={4}>
          {error}
        </InfoBox>
      );
    }}
  </FormContextConsumer>
);

export default GeneralError;
